import { useAxios } from "./useAxios"
import { Pagination } from "@/interfaces/Pagination"
import { useBot } from "./useBot"
import { UtmLink } from "@/interfaces/UtmLink"

const axios = useAxios()

export interface CreateUtmLinkDTO {
    campaignName: string
    source: string
    medium: string
    content: string
    leadStartParameterContent: string
}

export interface UpdateUtmLinkDTO {
    campaignName: string
    source: string
    medium: string
    content: string
    leadStartParameterContent: string
}

export interface GetAllUtmLinksParams {
  page?: string
  perPage?: string
}

export function useUtmLink() {
  const { selectedBot } = useBot()

  const create = async (payload: CreateUtmLinkDTO): Promise<UtmLink> => {
    const response = await axios.post(`/bots/${selectedBot.value?.id}/utm-links`, payload)

    return response.data
  }

  const update = async (id: number, payload: UpdateUtmLinkDTO): Promise<void> => {
    await axios.patch(`/bots/${selectedBot.value?.id}/utm-links/${id}`, payload)
  }

  const getAll = async (params?: GetAllUtmLinksParams): Promise<Pagination<UtmLink>> => {
    if (params) {
      params = Object.fromEntries(
        Object.entries(params).filter(([param, value]) => !!value)
      )
    }

    const response = await axios.get(`/bots/${selectedBot.value?.id}/utm-links`, { params })

    return response.data
  }

  const destroy = async (id: number): Promise<void> => {
    await axios.delete(`/bots/${selectedBot.value?.id}/utm-links/${id}`)
  }

  return {
    create,
    getAll,
    update,
    destroy
  }
}